import React from "react";

const SportsmenImageNba = ({ imageSrc, name, small }) => {
  if (imageSrc && typeof imageSrc === "string" && imageSrc.length > 0) {
    const src = (imageSrc.includes("http") || imageSrc[0] === '/') ? imageSrc : '/' + imageSrc;
    return (
      <img
        className={`sportsmen-image ${small ? "sportsmen-image--small" : ""}`}
        src={src}
        title={name}
      />
    );
  }
  return null;
};

export default SportsmenImageNba;
